import React from 'react'
import SqField from '../sq/SqField'
import HighlightText from './HighlightText'

const MobileSq = (props) => {
    return (
        <div className='mobile-sq d-block d-lg-none text-center'>
            <h2 className='m-0'>What's available at <HighlightText height='10px'>your address</HighlightText>?</h2>
            <div className='text-left px-3 mt-3'>
                <SqField />
            </div>
        </div>
    )
}

export default MobileSq



// WEBPACK FOOTER //
// ./resources/js/components/MobileSq.js